// extracted by mini-css-extract-plugin
export default {"mobileBreakPoint":"780px"};